// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"105":"72bc5659","137":"07bcadca","430":"721cd399","672":"a83f447e","895":"e8689a15"}[chunkId] + ".css";
};